import React from "react";
//import { Form, FormButton, FormContent, FormH1, FormInput, FormLabel, FormWrap, Icon, Text } from './SigninElements';

//import Footer from "../components/Footer";

// import Navbar from "../Navbar/index";

// import Sidebar from "../Sidebar/index";
import HeroSection from "../HeroSection";
import Apropos from "../Apropos/Apropos";
import Blog from "../Blog/Blog.jsx";


const Home = () => {
  // const [isOpen, setIsOpen] = useState(false);

  // const toggle = () => {
  //   setIsOpen(!isOpen);
  // };

  return (
    <>
      {/* <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} /> */}
      
      {/* <InfoSection {...homeObjFour} /> */}
      <HeroSection />
      <Apropos />
      <Blog />
      
             {/* <FormWrap>
                 <Icon to="/">Application transport</Icon>
                 <FormContent>
                     <Form action="#">
                         <FormH1>Se connecter à votre compte</FormH1>
                         <FormLabel htmlFor="for">Email</FormLabel>
                         <FormInput type="email" required />
                         <FormLabel htmlFor="for"> Password</FormLabel>
                         <FormInput type="password" required />
                         <FormButton type="submit">Valider</FormButton>
                         <Text>Mot de passe oublié</Text>
                     </Form>
                 </FormContent>
             </FormWrap> */}
          
      
      {/* <Footer /> */}
    </>
  );
};

export default Home;